import React from 'react';
import HeroStats from '../components/HeroStats';
import PrinciplesStrip from '../components/PrinciplesStrip';
import CapabilitiesSection from '../components/CapabilitiesSection';
import RecentHeadlinesPreview from '../components/RecentHeadlinesPreview';
import { usePageMeta, DEFAULT_DESCRIPTION } from '../hooks/usePageMeta';
import './LandingPage.css';

const AIM_PILLARS = [
  { letter: 'A', word: 'Agent' },
  { letter: 'I', word: 'Intelligence' },
  { letter: 'M', word: 'Model' },
];

const LandingPage = () => {
  usePageMeta({
    description: DEFAULT_DESCRIPTION,
    path: '/',
  });
  return (
    <div className="landing-page">
      <RecentHeadlinesPreview placement="top" />
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="hero-kicker">Global Intelligence Desk</div>
              <h1 className="hero-title">DarkNews</h1>
              <p className="hero-subtitle">
                The <strong>anti-establishment</strong> news platform — harvest independent
                sources and <strong>research with AI agents</strong>, without mainstream media bias.
              </p>
              <HeroStats />
            </div>
            <div className="col-lg-6">
              <div className="hero-image">
                <div className="capability-diagram aim-card">
                  <p className="capability-diagram-heading">Don't Assume Real Knowledge</p>
                  <div className="aim-wordmark" aria-hidden="true">
                    <span>A</span><span>I</span><span>M</span>
                  </div>
                  <ol className="aim-pillars" aria-label="AIM — Agent, Intelligence, Model">
                    {AIM_PILLARS.map((pillar) => (
                      <li key={pillar.letter} className="aim-pillar">
                        <span className="aim-pillar-letter" aria-hidden="true">{pillar.letter}</span>
                        <span className="aim-pillar-text">
                          Your <strong>{pillar.word}</strong>
                        </span>
                      </li>
                    ))}
                  </ol>
                  <div className="brand-tagline">Free The News</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PrinciplesStrip />
      <CapabilitiesSection />
    </div>
  );
};

export default LandingPage;
